import React, { useEffect } from "react";
import { CircularProgress, Typography } from "@material-ui/core";
import { useQuery, useLazyQuery, useMutation } from "@apollo/react-hooks";
import gql from "graphql-tag";
import moment from "moment";

import { useAlert } from "../../components/Alert";
import Grid from "../../components/Grid";
import LoadingModal from "../../components/LoadingModal";

const GET_FORECLOSURES = gql`
  query foreclosures(
    $obj_str: String
    $obj_share: String
    $obj_caseno: String
    $obj_another: String
    $desc: Boolean
    $pageSize: Int
    $page: Int
  ) {
    foreclosures(
      obj_str: $obj_str
      obj_share: $obj_share
      obj_caseno: $obj_caseno
      obj_another: $obj_another
      desc: $desc
      pageSize: $pageSize
      page: $page
    ) {
      count
      pageCount
      contents {
        obj_type
        obj_creditor
        obj_time
        obj_date_ymd
        obj_date_hi
        obj_price
        obj_margin
        obj_price_set
        obj_land_floor
        obj_total_floor
        obj_stop
      }
    }
  }
`;

export default function AuctionRecord({ data }) {
  const Alert = useAlert();
  const [getForeclosures, { data: getForeclosuresData, loading }] =
    useLazyQuery(GET_FORECLOSURES, {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,

      onError(error) {
        Alert.alert("通知", `${error}`, [
          {
            text: "確定",
            type: "ok",
          },
        ]);
      },
    });

  function price(
    obj_price_set,
    obj_type,
    obj_price,
    obj_land_floor,
    obj_total_floor
  ) {
    if (obj_price_set > 0) {
      if (obj_type === "H") {
        return (obj_price_set / obj_total_floor).toFixed(2);
      } else {
        return (obj_price_set / obj_land_floor).toFixed(2);
      }
    } else {
      if (obj_type === "H") {
        return (obj_price / obj_total_floor).toFixed(2);
      } else {
        return (obj_price / obj_land_floor).toFixed(2);
      }
    }
  }

  function bid(obj_date_ymd, obj_price_set, obj_stop) {
    if (moment(obj_date_ymd).isBefore(new Date()) && obj_price_set === 0) {
      if (obj_stop !== "") return "停拍";
      else return "流標";
    } else if (moment(obj_date_ymd).isBefore(new Date()) && obj_price_set > 0)
      return "得標";
    else return "待標";
  }

  useEffect(() => {
    if (!!data.obj_caseno) {
      getForeclosures({
        variables: {
          obj_str: data.obj_str,
          obj_share: data.obj_share,
          obj_caseno: data.obj_caseno,
          obj_another: data.obj_another,
          desc: false,
          pageSize: 999,
          page: 1,
        },
      });
    }
  }, [data]);
  if (false) {
    return (
      <Grid container item justify="center">
        <CircularProgress color="secondary" />
      </Grid>
    );
  } else {
    return (
      <>
        <LoadingModal loading={loading} />
        <Typography>{`【拍賣原因:${data.obj_creditor}】`}</Typography>
        {getForeclosuresData?.foreclosures?.contents.map((item, index) => {
          return (
            <Typography
              key={index}
              style={{
                color:
                  index + 1 ===
                  getForeclosuresData?.foreclosures?.contents.length
                    ? "#f44336"
                    : "#212121",
              }}
            >{`${
              item.obj_time === "0" ? "應買" : item.obj_time + "拍"
            }，${moment(item.obj_date_ymd).format("YYYY/MM/DD")}，總底價：${
              item.obj_price
            }萬元，保證金：${(item.obj_margin / 10000).toFixed(
              2
            )}萬元，坪單價：${price(
              item.obj_price_set,
              item.obj_type,
              item.obj_price,
              item.obj_land_floor,
              item.obj_total_floor
            )}坪／萬，${bid(
              item.obj_date_ymd,
              item.obj_price_set,
              item.obj_stop
            )}`}</Typography>
          );
        })}
      </>
    );
  }
}
